import React, { useState, useEffect  } from "react";
import { useParams, Link } from 'react-router-dom';
//import LoginBg from "./../images/login-bg.jpg";
import hviCoverImg from "./../images/hvi-cover-img.jpg";
//import Logo from "./../images/sustain-change-logo.png";
import {Helmet} from "react-helmet";
import configVars from "../config";
import { getWithExpiry, setWithExpiry } from '../common';
import Navigation from "../partials/Navigation";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import MembershipPlan from "../partials/Payments/MembershipPlan";

const Plans = () => {

    const { plan } = useParams();
    const [pricingPlans, setPricingPlans] = useState([]);
    const [loading, setLoading] = useState(false);
    const [membershipType, setMembershipType] = useState('private');
    const [paymentType, setPaymentType] = useState('monthly');
    const [selectedPlan, setSelectedPlan] = useState({});

    useEffect(() => {

        const savedPlans = getWithExpiry( 'sy_pricing_plans' );

        if ( savedPlans ) {
            setPricingPlans( savedPlans );

            if ( plan ) {
                const result = savedPlans.find( ({ sy_membership_slug }) => sy_membership_slug === plan );

                if ( result ) {
                    setSelectedPlan( result );
                }
            }

        } else {

            setLoading(true);

            (async () => {

                const response = await fetch(
                    `${configVars.apiUrl}sustainchange/v1/getpricingmemberships/`,
                    {
                      method: "GET",
                      headers: {
                        Authorization: `Basic ${configVars.auth}`,
                      },
                    }
                );
        
                const plansResponse = await response.json();
    
                if ( plansResponse ) {
                    //console.log( plansResponse );
    
                    setPricingPlans( plansResponse.data );
                    setWithExpiry( 'sy_pricing_plans', plansResponse.data );

                    const result = plansResponse.data.find( ({ sy_membership_slug }) => sy_membership_slug === plan );

                    if ( result ) {
                        setSelectedPlan( result );
                    }

                    setLoading(false);
                }
    
            })()

        }

    }, [plan]);

    const handleMembershipType = ( checked ) => {

        checked ? setMembershipType('business') : setMembershipType('private');

    }

    const handlePaymentType = ( checked ) => {
        checked ? setPaymentType('yearly') : setPaymentType('monthly');
    }

    // const handleMembershipSelect = ( type, plan ) => {

    //     setSelectedPlan( plan );

    // }

    return (
        <div className="main-wrapper">
			<Helmet>
				<title>Prenumerationsplan</title>
				<meta name="description" content="" />
			</Helmet>
			<Navigation />

			<div className="page-content-wrap">
				<HorizontalNav title="Prenumerationsplan" />
				
				<div className="py-5 pt-lg-0 page-content-inner">
                    <div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px'}}>
                        <img src={hviCoverImg} alt="te" className="w-100" style={{objectFit: 'cover'}} />
                        <div className="course-img-overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column dark-overlay">
                            <div className="flex-grow-1 d-flex align-items-center">
                                <h2 className="text-white display-6 text-center text-shadow single-article-title">
                                    { (plan && selectedPlan && Object.keys(selectedPlan).length !== 0) ? `${selectedPlan.sy_membership_name} prenumeration` : 'Pricing' }
                                </h2>
                            </div>


                            { plan && 
                                <span className="text-white p-3 d-flex w-100 dark-overlay">
                                    <span className="text-white pe-3"><i className="fa fa-long-arrow-left" aria-hidden="true"></i></span>
                                    <Link to="/plans" className="text-white">Gå tillbaka</Link>
                                </span>
                            }
                        </div>
                    </div>

						<div className="px-4" style={{maxWidth: '1400px'}}>

                            { plan &&
                                <MembershipPlan plans={pricingPlans} selectedPlan={selectedPlan} />
                            }

                            { !plan &&
                                <div className="d-flex flex-column align-items-center justify-content-center mt-5">
                                    <div className="mb-4 d-flex flex-column justify-content-center align-items-center text-center" style={{ maxWidth: "650px" }} >
                                        
                                        <p>Nu är det bara några steg kvar så är ditt köp klart!</p>
                                        <div className="switch-wrap mt-3 align-items-center d-none">
                                            <span className="pe-2 fw-bold">Privatperson</span>
                                            <div className="form-check form-switch d-flex align-items-center">
                                                <input className="form-check-input form-check-secondary" type="checkbox" role="switch" id="membershipType" onChange={ (e) => handleMembershipType( e.target.checked ) } />
                                                <label className="form-check-label ps-2 fw-bold" htmlFor="membershipType">Företag</label>
                                            </div>
                                        </div>
                                    </div>

                                    { loading &&
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border me-2 text-secondary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    }

                                    { ! loading &&

                                        <div className="mb-4 w-100">
                                            <div className="row justify-content-center position-relative">

                                                { pricingPlans &&
                                                    pricingPlans.map( ( plan, index ) => {
                                                        return(
                                                            <div className={`col-12 col-lg-4 h-100 ${ membershipType !== plan.sy_membership_type ? 'd-none' : ''}`} key={index}>
                                                                <div className="pricing-wrap border border-2 border-sy-black h-100 p-4 py-lg-5 d-flex flex-column text-center">
                                                                    <h3 className="fw-bold mb-4">{plan.sy_membership_name}</h3>
                                                                    <p>{plan.sy_membership_price_desc}</p>
                                                                    
                                                                    {paymentType === 'monthly' &&
                                                                        <span className="mt-5 mb-3 h4">{(plan.sy_membership_price_monthly*1.25)} kr/mån</span>
                                                                    }

                                                                    {paymentType === 'yearly' &&
                                                                        <span className="mt-5 mb-3 h4">{(plan.sy_membership_price_yearly*1.25)} kr/år</span>
                                                                    }

                                                                    { plan.sy_membership_type === 'business' &&
                                                                        <span className="mb-4">(exkl moms)</span>
                                                                    }

                                                                    { plan.sy_membership_type === 'private' &&
                                                                        <span className="mb-4">(inkl moms)</span>
                                                                    }
                                                                    <Link to={`/plans/${ plan?.sy_membership_slug}/${paymentType}`} className="btn btn-secondary rounded-pill px-4 text-uppercase" onClick={ () => setSelectedPlan( plan ) }>Köp Nu</Link>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>

                                            <div className="d-flex justify-content-center mt-4">
                                                <div className="switch-wrap d-flex align-items-center">
                                                    <span className="pe-2 fw-bold">Betala månadsvis</span>
                                                    <div className="form-check form-switch d-flex align-items-center">
                                                        <input className="form-check-input form-check-secondary" type="checkbox" role="switch" id="payType" onChange={ (e) => handlePaymentType( e.target.checked ) } />
                                                        <label className="form-check-label ps-2 fw-bold" htmlFor="payType">Betala årsvis</label>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    }

                                </div>
                            }
						</div>
				</div>

			</div>
		</div>
    );
}

export default Plans;